import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Button } from "@mui/material";
import ButterflyEffectTable from "./butterflyEffectTable";
import FilterMenu from "../../components/filterMenu";
import { useEffect, useState } from "react";
import { isValidInput } from "../../utils/validations";
import {
  useExportButterflyEffectMutation,
  useLazyGetButterflyEffectQuery,
} from "../../service/offer";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";

const ManageButterflyEffect = () => {
  const [getButterflyEffect] = useLazyGetButterflyEffectQuery();
  const [exportButterflyEffect] = useExportButterflyEffectMutation();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const butterflyEffectApi = async () => {
    try {
      setLoading(true);
      const response = await getButterflyEffect({
        search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setData(response?.data || []);
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const exportButterflyEffectApi = async () => {
    try {
      setLoading(true);
      const response: any = await exportButterflyEffect({
        format: "excel",
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.downloadUrl, "_blank");
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    butterflyEffectApi();
  }, [debouncedSearchTerm]);

  return (
    <>
      <Loader isLoad={loading} />
      <MainContainer>
        <div className="main_title d_flex">
          <h1>Butterfly Effect</h1>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Button
              className="btn btn_primary"
              onClick={exportButterflyEffectApi}
            >
              <img src="/static/images/export_icon.svg" alt="icon" /> Export
              Data
            </Button>
            <FilterMenu
              startDate={null}
              endDate={null}
              setStartDate={() => {}}
              setEndDate={() => {}}
            />
          </div>
        </div>

        <div className="cards table_cards v2">
          <ButterflyEffectTable
            setData={setData}
            data={data}
            butterflyEffectApi={butterflyEffectApi}
          />
        </div>
      </MainContainer>
    </>
  );
};

export default ManageButterflyEffect;
